import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchExhibitorEventById } from "api/exhibitorEvent.api";

export default function ViewExhibitorEvent() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);

  useEffect(() => {
    fetchExhibitorEventById(id).then((res) =>
      setData(res.data?.data)
    );
  }, [id]);

  if (!data) return <p className="p-6">Loading...</p>;

  const exhibitor = data.exhibitor_id;
  const event = data.event_id;

  return (
    <div className="p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">
          Exhibitor Event Details
        </h1>
        <button
          onClick={() => navigate(-1)}
          className="rounded-xl border px-4 py-2"
        >
          Back
        </button>
      </div>

      <Card title="Event Information">
        <Info label="Event Name" value={event?.event_name} />
        <Info label="Status" value={data.status} />
      </Card>

      <Card title="Exhibitor Information">
        <Info label="Exhibitor Name" value={exhibitor?.title} />
      </Card>

      <Card title="Audit Information">
        <Info
          label="Created At"
          value={new Date(data.createdAt).toLocaleString()}
        />
        <Info
          label="Updated At"
          value={new Date(data.updatedAt).toLocaleString()}
        />
      </Card>
    </div>
  );
}


function Card({ title, children }) {
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );
}
